// @flow

import React, { PureComponent } from 'react';
import { css } from 'emotion';

import StatusLabel from '../../../../../common/components/core/StatusLabel';
import DevicePreviewer from '../../../../../common/components/core/DevicePreviewer/DevicePreviewer';
import DeviceDropdown from '../../../../../common/components/core/DevicePreviewer/DeviceDropdown';
import DiscoAdPreview from './DiscoAdPreview';

import Colors from '../../../../../../styles/Colors';
import {
  GENERIC_ANDROID_DEVICE,
  PREVIEWER_DEVICE_OPTIONS
} from '../../discoAdsConstants';

const LABEL_TYPE = 'default';
const LABEL_COPY = 'AD PREVIEW';

const styles = {
  adPreviewerContainer: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1
  }),
  label: css({
    display: 'flex',
    alignSelf: 'flex-end',
    height: '35px',
    width: '130px',
    marginRight: '5px',
    backgroundColor: '#EBF6FF', // hard-coded to match default StatusLabel color which is not currently in the DSM
    borderRadius: '0px 0px 10px 10px'
  }),
  labelText: css({
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '14px',
    letterSpacing: '0.6px'
  }),
  devicePreviewerContainer: css({
    padding: '25px 50px 50px 50px'
  }),
  deviceStyles: css({
    border: '7px solid',
    borderRadius: '40px',
    borderColor: Colors['@white'],
    boxShadow: `1px 1px 14px 0 ${Colors['@gallery']}`,
    backgroundSize: 'auto',
    backgroundRepeat: 'unset'
  })
};

export type DiscoAdPreviewerProps = {
  headline: string,
  description: string,
  creativeImageUrl: ?string,
  campaignObjective: string
};

class DiscoAdPreviewer extends PureComponent<DiscoAdPreviewerProps> {
  render() {
    const {
      headline,
      description,
      creativeImageUrl,
      campaignObjective
    } = this.props;
    const {
      adPreviewerContainer,
      label,
      labelText,
      devicePreviewerContainer,
      deviceStyles
    } = styles;
    const testid = 'dac-ad-preview';
    return (
      <div className={adPreviewerContainer}>
        <StatusLabel
          type={LABEL_TYPE}
          text={LABEL_COPY}
          className={label}
          textClassName={labelText}
        />
        <DevicePreviewer
          device={GENERIC_ANDROID_DEVICE}
          containerClassName={devicePreviewerContainer}
          deviceStyles={deviceStyles}
          testid={testid}
          deviceDropdown={
            <DeviceDropdown
              value={PREVIEWER_DEVICE_OPTIONS[0]}
              disabled
              onChange={(e, action) => {}}
              i13nLabel="Disco Ads Creator - Device Previewer Dropdown"
              testid={testid}
            />
          }
        >
          <DiscoAdPreview
            headline={headline}
            description={description}
            creativeImageUrl={creativeImageUrl}
            campaignObjective={campaignObjective}
          />
        </DevicePreviewer>
      </div>
    );
  }
}

export default DiscoAdPreviewer;
